/* ============
 * Dashboard
 * ============
 *
 * This is the dashboard page.
 */

import { mapGetters, mapMutations } from 'vuex';
import Forms from '../../utils/forms/forms';
import modulesService from '../../services/modules';
import partnerService from '../../services/partner';
import accountService from '../../services/account';

export default {
  data() {
    return {
      form: new Forms({
        public_marketplace: {
          value: 0,
          type: 'switch',
        },
        marketplaces_enabled: {
          value: [],
          type: 'checkboxGroup',
        },
      }),
      loading: false,
    };
  },

  props: {
    module: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      account: 'account',
      modules: 'allModules',
      partners: 'allPartners',
    }),
  },

  mounted() {
    this.loading = true;
    Promise.all([partnerService.all()]).then(() => {
      this.loading = false;
    });
  },

  watch: {
    partners(allPartners) {
      if (allPartners) {
        this.form.setOptions('marketplaces_enabled', allPartners);
      }
    },
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    /**
     * Fetch the component's required resources.
     */
    getResources() {},

    subscribe() {
      this.form.loading = true;
      const data = this.form.data();
      const partnerIds = [];
      this.form.marketplaces_enabled.forEach(m => {
        const partner = this.partners.find(p => p.name === m);
        partnerIds.push(partner.id);
      });
      data.marketplaces_enabled = partnerIds;
      const obj = Object.assign(
        { module_id: this.module.id },
        data
      );
      modulesService
        .subscribe(this.module.id, obj)
        .then(() => {
          Promise.all([modulesService.items(), accountService.find()]).then(
            () => {
              this.closeModal();
            }
          );
        })
        .catch((error) => {
          const message = error.data ? error.data.message : 'Field Required';
          this.$message({
            showClose: true,
            message,
            customClass: 'error',
          });
          this.form.recordErrors(error);
          this.form.loading = false;
        });
    },
    /*
     * Closes the modal
     */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
    VMessage: require('./../../components/form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/marketplaceModuleSetup/marketplaceModuleSetup.js